import { Component } from 'react';
import { connect } from 'dva';
import { Avatar, Popover } from 'antd';
import { StoreState } from '@src/interfaces';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import CustomScrollbars from '@src/util/CustomScrollbars';
import languageData from '@src/containers/Topbar/languageData';
import { GlobalOutlined } from '@ant-design/icons';
// import {userSignOut} from "appRedux/actions/Auth";

const STORAGE_KEY = 'app_locale';

// Helper function to get locale from localStorage
const getStoredLocale = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error reading locale from localStorage:', error);
  }
  return null;
};

class UserProfile extends Component<
  {
    dispatch?: any;
    authUser?: any;
    locale?: any;
  } & WrappedComponentProps
> {
  languageMenu = () => (
    <CustomScrollbars className='gx-popover-lang-scroll'>
      <ul className='gx-sub-popover'>
        {languageData.map((language) => (
          <li
            className='gx-media gx-pointer'
            key={JSON.stringify(language)}
            onClick={() =>
              this.props.dispatch({
                type: 'settings/switchLanguage',
                payload: language,
              })
            }
          >
            <i className={`flag flag-24 gx-mr-2 flag-${language.icon}`} />
            <span className='gx-language-text'>{language.name}</span>
          </li>
        ))}
      </ul>
    </CustomScrollbars>
  );

  render() {
    const { authUser, locale } = this.props;
    let storedLocale = getStoredLocale();
    if (!locale) storedLocale = storedLocale || { locale: 'vi' };
    const userMenuOptions = (
      <ul className='gx-user-popover'>
        <li
          onClick={() => {
            this.props.dispatch({
              type: 'auth/userSignOut',
            });
          }}
        >
          {this.props.intl.formatMessage({ id: 'app.userAuth.logout' })}
        </li>
        {/* <li>
          <Popover
            overlayClassName='gx-popover-horizantal'
            placement='bottomRight'
            content={this.languageMenu()}
            trigger='click'
          >
            <span
              className='gx-pointer gx-flex-row gx-align-items-center'
              style={{
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                padding: '8px',
                borderRadius: '4px',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              }}
            >
              {storedLocale?.icon ? (
                <i
                  className={`flag flag-24 flag-${storedLocale.icon}`}
                  style={{ marginRight: '4px' }}
                />
              ) : (
                <GlobalOutlined style={{ fontSize: '20px', color: '#666' }} />
              )}
            </span>
          </Popover>
        </li> */}
      </ul>
    );

    return (
      <div className='gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row'>
        <Popover
          placement='bottomRight'
          content={userMenuOptions}
          trigger='click'
        >
          <Avatar
            src='https://gravatar.com/avatar/047cd01ffa900b9cb17cde803f0fa515?s=400&d=mp&r=x'
            className='gx-size-40 gx-pointer gx-mr-3'
            alt=''
          />
          <span className='gx-avatar-name'>
            {authUser ? `${authUser.name}` : ''}
            <i className='icon icon-chevron-down gx-fs-xxs gx-ml-2' />
          </span>
        </Popover>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }: StoreState) => {
  const { authUser } = auth;
  return { authUser };
};
export default connect(mapStateToProps, null)(injectIntl(UserProfile));
